import { StatsData } from '@shared';
import { TableColumn } from '@shared/interfaces';

export const INSTALLATIONS_STATS: StatsData[] = [
    {
        title: 'Scheduled',
        description: 'Upcoming installations with confirmed schedules.',
        iconKey: 'calendar',
        total: '0',
        stats: [{ label: 'Planned Installations', value: '', variant: 'normal' }],
    },
    {
        title: 'Last Month',
        description: 'Total installations during the previous month.',
        iconKey: 'arrow-trending-right   ',
        total: '79',
        stats: [
            {
                label: 'May Installations',
                value: '+21%',
                variant: 'trend',
                colorClass: 'text-green-500',
                trend: { value: 'up', colorClass: 'text-green-500' },
            },
        ],
    },
    {
        title: 'This Month',
        description: 'Active installations for the current month.',
        iconKey: 'clock',
        total: '51',
        stats: [
            {
                label: 'June Installations',
                value: '+12.5%',
                variant: 'trend',
                colorClass: 'text-green-500',
                trend: { value: 'up', colorClass: 'text-green-500' },
            },
        ],
    },
    {
        title: 'Next Month',
        description: 'Total installations for the coming month.',
        iconKey: 'arrow-up-right',
        total: '0',
        stats: [{ label: 'July Installations', value: '', variant: 'normal' }],
    },
];

//Table

/**
 * The columns data for the licenses table.
 */
export const INSTALLATIONS_DUMMY_DATA = [
    {
        licenseKey: '7a2c15a9-1544-4929-a786-17e58f692a95',
        host: 'Test Build Nov 2023',
        dealerAlias: 'NCMPS - SDA',
        businessName: 'Apitest Business',
        licenseType: '—',
        installationDate: '10/01/24 12:02 AM',
        installRequestDate: '10/01/24 12:02 AM',
    },
    {
        licenseKey: 'b3d4e5f6-2233-4455-b897-28f69g803b06',
        host: 'Demo Host Alpha',
        dealerAlias: 'NCMPS - LAS',
        businessName: 'Demo Business Co.',
        licenseType: 'Ad',
        installationDate: '11/15/24 09:30 AM',
        installRequestDate: '11/10/24 08:00 AM',
    },
    {
        licenseKey: 'c4e5f6a7-3344-5566-c908-39g7ah914c17',
        host: 'Production Node 7',
        dealerAlias: 'NCMPS - MNL',
        businessName: 'Prime Media Inc.',
        licenseType: 'Menu',
        installationDate: '12/03/24 02:15 PM',
        installRequestDate: '12/01/24 10:00 AM',
    },
    {
        licenseKey: 'd5f6a7b8-4455-6677-d019-40h8bi025d28',
        host: 'West Branch Display',
        dealerAlias: 'NCMPS - CEBusiness',
        businessName: 'Visuals Corp.',
        licenseType: 'Ad',
        installationDate: '01/08/25 11:45 AM',
        installRequestDate: '01/05/25 09:00 AM',
    },
    {
        licenseKey: 'e6a7b8c9-5566-7788-e12a-51i9cj136e39',
        host: 'East Wing Screen',
        dealerAlias: 'NCMPS - DAV',
        businessName: 'BrightSign Media',
        licenseType: 'Menu',
        installationDate: '02/20/25 03:00 PM',
        installRequestDate: '02/18/25 01:00 PM',
    },
];

export const INSTALLATIONS_COLUMNS: TableColumn[] = [
    {
        field: 'licenseKey',
        header: 'License Key',
        width: '250px',
        type: 'status-copy',
        hasRedirect: true,
    },
    { field: 'host', header: 'Hosts', width: '200px' },
    { field: 'dealerAlias', header: 'Dealer Alias', width: '200px' },
    { field: 'businessName', header: 'Business Name', width: '200px' },
    { field: 'licenseType', header: 'License Type', width: '180px' },
    { field: 'installationDate', header: 'Installation Date', width: '180px' },
    { field: 'installRequestDate', header: 'Install Request Date', width: '200px' },
    // {
    //     field: 'actions',
    //     header: 'Actions',
    //     width: '150px',
    //     type: 'actions',
    //     actions: [
    //         { icon: 'screenshot', name: 'screenshot' },
    //         { icon: 'edit', name: 'edit' },
    //         { icon: 'delete', name: 'delete', color: 'red' },
    //     ],
    // },
];
